<app-nav-menu></app-nav-menu>
<main class="main">
  <div class="supplier_main container">
    <div class="supplier_title">Offline Supplier List</div>
    <div class="accordion">
      <div>
        <div id="headingOne">

          <div class="supp-card" (click)="toggleAccordion()" [attr.aria-expanded]="isOpen">
            <div class="accordian_left">
              <i class="accor_icon">Offline Supplier</i>
            </div>
            <div class="accordian_right">

              <i class="uil" [ngClass]="isOpen ? 'uil-angle-up' : 'uil-angle-down'"></i>
              <i class="uil uil-plus-circle accor_icon" (click)="createSupplier(); $event.stopPropagation()"></i>
            </div>
          </div>
        </div>

        @if (isOpen) {
          <div class="supplier-body">
            @for (supplier of offlineSuppliersDetails; track supplier; let i = $index) {
              <div>
                <div class="inner_top">
                  <div class="inner_heading">
                    <input type="text" hidden name="offlineSupplierName{{i}}" [(ngModel)]="supplier.offlineSupplierName">
                    <label id="offlineSupplierName">{{supplier.offlineSupplierName}}</label>
                  </div>
                  <div class="switch_add">
                    <label class="switch">
                      <input type="checkbox" name="isActive{{i}}" [(ngModel)]="supplier.isActive" (change)="changeStatus(supplier,$event)">
                      <span></span>
                    </label>
                    <i class="uil uil-edit edit_icon" style="margin-left:20px; font-size:medium; cursor: pointer;"
                    (click)="updateSupplier(supplier.offlineSupplierId)"></i>
                  </div>
                </div>
                <div class="inner_main">
                  <div class="inner_body">
                    <dx-data-grid #suppliersGrid
                      [dataSource]="supplier.officeSupplierList"
                      [showBorders]="true"
                      [showRowLines]="true"
                      [allowColumnResizing]="true"
                      [columnAutoWidth]="true">
                      <dxo-scrolling mode="standard" [useNative]="true"></dxo-scrolling>
                      <dxi-column [visible]="false" dataField="offlineSupplierId" alignment="center"></dxi-column>
                      <dxi-column dataField="backOfficeCompany" caption="Back Office Company" [minWidth]="160" dataType="string" alignment="center"></dxi-column>
                      <dxi-column dataField="backOfficeSupplier" caption="Back Office Supplier" [minWidth]="150" dataType="string" alignment="center"></dxi-column>
                      <dxi-column dataField="offlinePcc" caption="Offline PCC" [minWidth]="120" dataType="string" alignment="center"></dxi-column>
                      <div *dxTemplate="let data of 'statusCellTemplate'">
                        <p-toggleswitch [(ngModel)]="supplier.data.isActive" name="isActive{{supplier.data.id}}"></p-toggleswitch>
                      </div>
                      <dxo-search-panel [visible]="true"></dxo-search-panel>
                      <dxo-paging [pageSize]="10"></dxo-paging>
                      <dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[10, 25, 50, 100]"></dxo-pager>
                    </dx-data-grid>
                  </div>
                </div>
              </div>
            }
          </div>
        }
      </div>
    </div>
  </div>
</main>

